import { Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getDataUser } from "../../../config/Redux/action";

const DashboardUser = () => {
    const dispatch = useDispatch();
    const [users, setUsers] = useState([]);

    useEffect(() => {
    const getData = async () => {
      const data = await dispatch(getDataUser());
      setUsers(
        data.map((user, index) => {
          return {
            key: index,
            no: index + 1,
            name: user.data.name,
            email: user.data.email,
          };
        }),
      );
    };
    getData();
    },[dispatch])

    const dataSource = users;

    const columns = [
      {
        title: 'No',
        dataIndex: 'no',
        key: 'no',
        align: 'center',
        width: '10%',
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        align: 'center',
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        align: 'center',
      },
    ];
    return(
       <Table dataSource={dataSource} columns={columns} />
    )
}

export default DashboardUser